import styled from 'styled-components';
// components
import RowItem from 'components/molecules/class/card/RowItem';
// styles
import { mediaQuery, palette } from 'cds/styles';

/**
 * 클래스 Row type 리스트
 * @param {object} props
 * @param {import('types/slices/main').RecommendClass[]| import('types/slices/main').LowPriceClass[]} props.classList
 * @param {boolean} props.showSalePer 할인율 노출 여부
 * @param {boolean} props.showPrice 가격 노출 여부
 */
const ClassRowList = ({ list = [], ...props }) => {
  const ListItems = list.map(v => {
    return (
      <ListItem key={v.class_id} title={v.class_id}>
        <RowItem data={v} {...props} />
      </ListItem>
    );
  });

  return <List>{ListItems}</List>;
};

const List = styled.ul`
  font-size: 0;
`;

const ListItem = styled.li`
  display: inline-block;
  width: 100%;
  padding: 12px 0;
  border-bottom: 1px solid ${palette.system.BNB};

  &:last-of-type {
    border-bottom: none;
  }

  ${mediaQuery.large} {
    border-bottom: 1px solid ${palette.system.grey};
  }
`;
export default ClassRowList;
